export function buildFaunaArchiveUpdates(alertEntry, archivedAt = Date.now()) {
  const id = String(alertEntry?.id || "").trim();
  if (!id) throw new Error("Alerta de fauna sem identificador.");

  const archivedEntry = { ...(alertEntry || {}) };
  delete archivedEntry.archived;
  delete archivedEntry.storagePath;

  return {
    [`alertsHistory/fauna/${id}`]: {
      ...archivedEntry,
      id,
      category: "fauna",
      status: "archived",
      archivedAt,
    },
    [`alerts/fauna/${id}/status`]: "archived",
    [`alerts/fauna/${id}/archivedAt`]: archivedAt,
  };
}
